<template>
	<div class="Layout-Plain">
		<slot />
	</div>
</template>

<script>
export default {};
</script>
